<template>
  <div>
    <div class="main-box">
      <div class="settings-row">
        <profile />
      </div>
      <div class="settings-row">
        <change-password />
      </div>
    </div>
  </div>
</template>

<script>
  import Profile from '@/components/settings/Profile.vue'
  import ChangePassword from '@/components/settings/ChangePassword.vue'

  export default {
    components: {
      Profile,
      ChangePassword
    }
  }
</script>

<style lang="scss" scoped>
  .main-box{
    .settings-row:not(:first-child) {
      margin-top: 2rem;
    }
  }
</style>
